import { atom, useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import React from 'react';
import { swapModeAtom, fromAmountAtom, toAmountAtom, prefillIdAtom } from '../../../atoms/index.js';
const canResetAtom = atom((get) => {
    const swapMode = get(swapModeAtom);
    const fromAmount = get(fromAmountAtom);
    const toAmount = get(toAmountAtom);
    const prefillId = get(prefillIdAtom);
    return swapMode === 'ExactIn' ? fromAmount.isPositive : toAmount.isPositive || !!prefillId;
});
const ResetButton = ({ Component, className, style, onPress }) => {
    const canReset = useAtomValue(canResetAtom);
    const handlePress = useAtomCallback((_, set) => {
        onPress?.();
        set(prefillIdAtom, null);
        set(fromAmountAtom, undefined);
        set(toAmountAtom, undefined);
    }, [onPress]);
    if (!Component)
        return null;
    return React.createElement(Component, { visible: canReset, className: className, style: style, onPress: handlePress });
};
export default ResetButton;
